import React from 'react';
import SEO from 'react-seo-component';
import { useSiteMetadata } from 'hooks/useSiteMetadata';

const Index = () => {
	const { title, description, siteUrl, siteLanguage, siteLocale, twitterUsername } =
		useSiteMetadata();

	return (
		<>
			<SEO
				title={`Home`}
				titleTemplate={title}
				description={description}
				pathname={siteUrl}
				siteLanguage={siteLanguage}
				siteLocale={siteLocale}
				twitterUsername={twitterUsername}
			/>

			<div className="home">
				<h1 id="site-name">{title}</h1>
				<p className="site-description">{description}</p>
			</div>
		</>
	);
};

export default Index;
